export default __webpack_public_path__ + "static/media/Button_Tooltip_exclamation.5b7045e9.svg";